var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('v-table',{ref:"table",attrs:{"items-provider":_vm.provider,"fields":_vm.fields,"name":"tachograph-wrong-driver","pagination":"server","search":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }